import React from 'react'
import PropTypes from 'prop-types'

import { Menu } from 'semantic-ui-react'

const PaginationItem = ({ active, page, setPage }) => (
  <Menu.Item active={active} content={page} onClick={!active ? () => setPage(page) : null} />
)

PaginationItem.propTypes = {
  active: PropTypes.bool,
  page: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
}

PaginationItem.defaultProps = {
  active: false,
}

export default PaginationItem
